import React from 'react';
export function FooterSection() {
  return <footer className="py-12 bg-black border-t border-white/10 text-center relative z-10" data-id="element-229">
      <div className="container mx-auto px-4" data-id="element-230">
        
        {/* Logo / Marca */}
        <h3 className="text-2xl font-bold text-white mb-6 tracking-tight" data-id="element-231">
          DIGITAL<span className="text-cyan-500" data-id="element-232">SOLVEX</span>
        </h3>

        {/* Enlaces Legales (Requeridos por Facebook) */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-8 text-sm text-gray-500 mb-8" data-id="element-233">
          <a href="#" className="hover:text-white transition-colors" data-id="element-234">Términos de Servicio</a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-235">Política de Privacidad</a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-236">Política de Reembolso</a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-237">Contacto</a>
        </div>

        {/* Copyright */}
        <p className="text-xs text-gray-600" data-id="element-238">
          © 2026 Digital Solvex. Todos los derechos reservados. <br data-id="element-239" />
          Este sitio no es parte del sitio web de Facebook o Facebook Inc. Además, este sitio no está respaldado por Facebook de ninguna manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}